import { redirect } from '@tanstack/react-router';
import { useAuthStore } from '@/store/auth.store';
import { GEO_ACCESS } from '@/features/auth/utils/geo-access';
import { USER_TYPE } from '@/features/users/constants/user.constants';

export function requireOfficeAccess(): void {
  const { geoAccess, user } = useAuthStore.getState();
  const isAdmin = user?.userTypeId === USER_TYPE.SA || user?.userTypeId === USER_TYPE.ADM;

  if (!isAdmin && geoAccess !== GEO_ACCESS.OFFICE) {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack redirect is thrown by design
    throw redirect({ to: '/' });
  }
}
